import { ApolloProvider, InMemoryCache } from "@apollo/client";
import { clientNeoAuth, clientNeoDocs } from "@neonumy/api-clients";
import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";
import { hotjar } from "react-hotjar";
import { v1 as uuidv1 } from "uuid";
import App from "./App";
import { StrictMode } from "react";

sessionStorage.setItem("tabId", uuidv1());

(clientNeoDocs.cache as InMemoryCache).policies.addTypePolicies({
  BookEntryType: {
    fields: {
      entryVats: { merge: false },
    },
  },
});

if (import.meta.env.PROD && import.meta.env.VITE_HOTJAR) {
  hotjar.initialize({
    id: Number(import.meta.env.VITE_HOTJAR),
    sv: 6,
  });
}

if (import.meta.env.VITE_ENV !== "local") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || "development",
    release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
    beforeSend(event) {
      const errorMessage = event?.exception?.values?.[0]?.value;
      const ignoredMessages = [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications.",
        "NetworkError when attempting to fetch resource.",
        "Socket closed with event 1011 keepalive ping timeout",
        "Failed to fetch",
        "network error",
        "Invalid Token",
        "Load failed",
        "Not allowed",
        "sendWithPromise",
        "Bad Gateway",
        "Service Unavailable",
        "Service Temporarily Unavailable",
        "Gateway Timeout",
        "Received status code 500",
        "Cannot release a lock that's no longer owned",
        "Cannot read properties of null (reading 'appendChild')",
        "is not valid JSON",
      ];

      if (ignoredMessages.some(msg => errorMessage?.includes(msg))) {
        return null;
      }
      return event;
    },
  });
}

Sentry.setTag("CI_COMMIT_SHORT_SHA", import.meta.env.VITE_CI_COMMIT_SHORT_SHA);

const hashElement = document.getElementById("hash");
if (hashElement) {
  hashElement.innerText = import.meta.env.VITE_CI_COMMIT_SHORT_SHA || "";
}

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <StrictMode>
    <ApolloProvider client={clientNeoAuth}>
      <App />
    </ApolloProvider>
  </StrictMode>,
);
